<template>
    <div>
        <div class="faqBlock">
            <div v-show="$parent.$parent.editMode" class="is-pulled-right"><i class="fa fa-trash right10 top5 is-size-7 handCursor" @click="removeItem"></i></div>
            <div ref="question" :contenteditable="$parent.$parent.editMode" class="faqQuestion handCursor" @click="toggle" v-html="item.q" @focus="setDirty('qFocused')" @blur="blurIt('qFocused')" :class="{'cmsItemFocused': qFocused}"></div>
            <div v-if="$parent.$parent.editMode" class="is-pulled-left"><i  v-show="index>0" class="fa fa-arrow-up handCursor" @click="moveUp"></i><br><i v-show="index < $parent.params.faqs.length -1" class="fa fa-arrow-down handCursor" @click="moveDown"></i></div>
            <div ref="answer" :contenteditable="$parent.$parent.editMode" class="faqAnswer left20" v-show="open || $parent.$parent.editMode" v-html="item.a"  @focus="setDirty('aFocused')" @blur="blurIt('aFocused')" :class="{'cmsItemFocused': aFocused}"></div>
        </div>
    </div>
</template>

<script>

import { AZEventBus } from './AZEventBus'

export default{
    name: 'FAQitem',
    props: ['item', 'index'],
    data: function(){
        return {
            open: false,
            qFocused: false,
            aFocused: false,
            dirty: ''
        }
    },

    mounted: function(){
        if(this.$parent.$parent.editMode)
             this.open= true
        else   
            this.open = false

    },

    methods: {
       

        moveUp: function(){
           var el = this.$parent.params.faqs.splice(this.index, 1)
           this.$parent.params.faqs.splice(this.index -1, 0, el[0])
        },

        moveDown: function(){
            var el = this.$parent.params.faqs.splice(this.index, 1)
            this.$parent.params.faqs.splice(this.index +1, 0, el[0])
        },

        toggle: function(){
            if(!this.$parent.$parent.editMode){
                this.open = !this.open;
            } else {

            }
        },

        setDirty: function(el){
            this[el] = true
            if(el == qFocused){
                this.dirty = this.$refs.question.innerHTML
            } else {
                this.dirty = this.$refs.answer.innerHTML
            }
        },

        blurIt: function(el){
            this.qFocused = false
            this.item.q = this.$refs.question.innerHTML
            this.aFocused = false
            this.item.a = this.$refs.answer.innerHTML

            if(el == 'qFocused'){
                if(this.dirty != this.$refs.question.innerHTML)
                    AZEventBus.$emit('pageChanged', null)
            } else {
                this.dirty != this.$refs.answer.innerHTML
                if(this.dirty != this.$refs.answer.innerHTML)
                    AZEventBus.$emit('pageChanged', null)
            }
        }, 

        removeItem: function(val){
            this.$parent.removeItem(this.index)
            AZEventBus.$emit('pageChanged', null)
        }
    }



}
</script>